import HomePage from './pages/HomePage';
import { Header, Footer } from './components/Layout';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useAuth } from './contexts/AuthContext';
import { PropertyProvider } from './contexts/PropertyContext';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProperties from './pages/admin/AdminProperties';
import PropertyForm from './pages/admin/PropertyForm';
import AdminClients from './pages/admin/AdminClients';
import ClientForm from './pages/admin/ClientForm';
import AdminLeads from './pages/admin/AdminLeads';
import AdminOwners from './pages/admin/AdminOwners';
import OwnerForm from './pages/admin/OwnerForm';
import AdminReports from './pages/admin/AdminReports';
import ChangePassword from './pages/admin/ChangePassword';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-blue"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

const AdminLoginWrapper = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-blue"></div>
      </div>
    );
  }

  if (user) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <AdminLogin />;
};

function AppContent() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <div className="App font-body">
            <Header />
            <HomePage />
            <Footer />
          </div>
        }
      />

      <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route
        path="/admin/*"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="properties" element={<AdminProperties />} />
        <Route path="properties/new" element={<PropertyForm />} />
        <Route path="properties/:id" element={<PropertyForm />} />

        <Route path="owners" element={<AdminOwners />} />
        <Route path="owners/new" element={<OwnerForm />} />
        <Route path="owners/:id" element={<OwnerForm />} />

        <Route path="clients" element={<AdminClients />} />
        <Route path="clients/new" element={<ClientForm />} />
        <Route path="clients/:id" element={<ClientForm />} />
        <Route path="leads" element={<AdminLeads />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route index element={<Navigate to="dashboard" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <PropertyProvider>
        <AppContent />
        <Toaster position="top-right" richColors closeButton />
      </PropertyProvider>
    </BrowserRouter>
  );
}

export default App;

